module.exports = __webpack_public_path__ + "img/the-le-chi-tiet-golf-private-26072024-hình ảnh-4.3c41cd8f.jpg";